import { IndoorDateRange, IndoorFloor, IndoorForklift, IndoorPeriod, LayerVisibility } from '../models/indoor-maps.model';
import { IndoorHourWindow, IndoorView } from '../models/indoor-analytics.model';

export interface IndoorMapsInitialState {
    selectedCompany: string | null;
    selectedFloor: string | null;
    floors: IndoorFloor[];
    floorForklifts: IndoorForklift[];
    selectedForklifts: string[];
    period: IndoorPeriod;
    dates: IndoorDateRange;
    layerVisibility: LayerVisibility;
    layerDefaultsVersion?: number;
    is3D: boolean;
    view: IndoorView;
    hours: IndoorHourWindow | null;
}

// Bumped when a layer default changes, so state persisted with older defaults picks up the new ones.
export const LAYER_DEFAULTS_VERSION = 2;

export const defaultLayerVisibility: LayerVisibility = {
    zones: true,
    roads: true,
    beacons: false,
    racks: true,
    wallsColumns: true,
    equipment: true,
    units: true,
    labels: true,
    detail: true
};

// Beacons used to be on by default; state saved before version 2 gets them switched off once.
export const resolveLayerVisibility = (state: Pick<IndoorMapsInitialState, 'layerVisibility' | 'layerDefaultsVersion'>): LayerVisibility => {
    const saved = { ...defaultLayerVisibility, ...state.layerVisibility };
    return state.layerDefaultsVersion === LAYER_DEFAULTS_VERSION ? saved : { ...saved, beacons: false };
};

const initialIndoorMapsState: IndoorMapsInitialState = {
    selectedCompany: null,
    selectedFloor: null,
    floors: [],
    floorForklifts: [],
    selectedForklifts: [],
    period: IndoorPeriod.LastDay,
    dates: {
        startDate: null,
        endDate: null
    },
    layerVisibility: defaultLayerVisibility,
    layerDefaultsVersion: LAYER_DEFAULTS_VERSION,
    is3D: false,
    view: 'zoneTime',
    hours: null
};

export default initialIndoorMapsState;
